import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const DoBetterRoot = styled('section', {
  width: '100%',
  backgroundColor: '$accent-white',
})

export const DoBetterLayout = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  width: '100%',
  margin: 'auto',
  maxWidth: '500px',
  padding: '$5 $3 $5 $3',
  gap: '$2',
  '@bp2': {
    maxWidth: '1440px',
    gap: '$3',
    padding: '$7 $3',
  },
})

export const Title = styled('h3', {
  fontSize: '$h2',
  fontFamily: '$display',
  fontWeight: '$regular',
  lineHeight: '$h2',
  '@bp2': {
    fontSize: '$h2',
  },
})

export const Subtitle = styled(Text, {
  width: '100%',
  maxWidth: '340px',

  '@bp2': {
    maxWidth: '1014px',
  },
})

export const Heading = styled('div', {
  '& > h2': {
    marginBottom: '$2',
  },
  '@bp2': {
    '& > h2': {
      marginBottom: '$3',
    },
  },
})

export const HeadingTitle = styled('h2', {
  fontSize: '$h2',
  fontFamily: '$display',
  fontWeight: '$regular',
  lineHeight: '$h1',
  '@bp2': {
    fontSize: '$h1',
  },
})

export const ComparisonBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '$5',
  alignItems: 'center',
  marginTop: '$3',
  width: '100%',

  '@bp2': {
    flexDirection: 'row',
    gap: '$4',
    marginTop: '$4',
  },

  '@bp3': {
    gap: '$7',
  },

  variants: {
    compare: {
      true: {
        marginTop: '0',
      },
    },
  },
})

export const OptionColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '500px',

  '@bp3': {
    maxWidth: '518px',
  },
})

export const KibbleImage = styled('div', {
  height: '250px',
  position: 'relative',
  aspectRatio: '1/1.1',
  '@bp2': {
    width: '300px',
    height: '325.5px',
  },
})

export const RawFoodImage = styled('div', {
  height: '250px',
  position: 'relative',
  aspectRatio: '8/7',
  '@bp2': {
    width: '370px',
    height: '326.6px',
  },
})

export const ImageBox = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',

  '&.kibble': {
    height: '270px',
  },
  '&.raw': {
    height: '290px',
  },

  '@bp2': {
    '&.kibble': {
      height: '350px',
    },
    '&.raw': {
      height: '350px',
    },
  },
})

export const FeaturesList = styled('div', {
  width: '100%',
})

export const ButtonBox = styled('div', {
  marginTop: '$3',
  '@bp2': {
    marginTop: '$4',
  },
})

export const Feature = styled('div', {
  borderTop: '1px solid $accent-black',
  padding: '$2',

  '&:first-child': {
    borderTop: '2px solid $accent-black',
  },
  '&:last-child': {
    borderBottom: '2px solid $accent-black',
  },
})
